import moment from 'moment'

export const formatDate = (date: string | Date | number, format: string = 'DD/MM/YYYY'): string => {
  if (!date) return ''
  return moment(date).format(format)
}
